import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/google-play-badge.png")